import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const MessageIcon = memo(({ fontSize = 18, color = colors.basic.black, className, style }: SvgIconProps) => (
  <SvgIcon width="19" height="22" viewBox="0 0 19 22" fill="none" className={className} style={{ fontSize, ...style }}>
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17102 0.750089C5.86625 0.734898 2.86099 2.66289 1.49719 5.67318C0.133377 8.68346 0.665596 12.2141 2.85619 14.6886L1.80238 20.75L7.29277 17.3656C10.4448 18.0892 13.7326 16.9423 15.7507 14.4152C17.7687 11.8881 18.1598 8.42798 16.7569 5.51414C15.3539 2.6003 12.405 0.748381 9.17102 0.750089Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
));
